import { services } from '../../../../api/feathers';

export const GET_FIRMWARE_VERSION_UPDATES = 'GET_FIRMWARE_VERSION_UPDATES';
export const GET_FIRMWARE_VERSION_UPDATE = 'GET_FIRMWARE_VERSION_UPDATE';
export const ADD_FIRMWARE_VERSION_UPDATES = 'ADD_FIRMWARE_VERSION_UPDATES';
export const UPDATE_FIRMWARE_VERSION_UPDATES = 'UPDATE_FIRMWARE_VERSION_UPDATES';

export function getFirmwareVersionUpdates(query = {}) {
  return (dispatch) =>
    services.firmwareVersionUpdates.find(query).then((response) =>
      dispatch({
        type: GET_FIRMWARE_VERSION_UPDATES,
        payload: response?.data ? response.data : response,
      })
    );
}

export function getFirmwareVersionUpdate(id) {
  return (dispatch) =>
    services.firmwareVersionUpdates.get(id).then((response) =>
      dispatch({
        type: GET_FIRMWARE_VERSION_UPDATE,
        payload: response,
      })
    );
}

export function addFirmwareVersionUpdates(firmwareVersionUpdate) {
  return (dispatch) =>
    services.firmwareVersionUpdates
      .create(firmwareVersionUpdate)
      .then((response) =>
        dispatch({
          type: ADD_FIRMWARE_VERSION_UPDATES,
          payload: response,
        })
      )
      .then(() => dispatch(getFirmwareVersionUpdates()));
}

export function updateFirmwareVersionUpdates(id, firmwareVersionUpdate) {
  return (dispatch) =>
    services.firmwareVersionUpdates
      .patch(id, firmwareVersionUpdate)
      .then((response) =>
        dispatch({
          type: UPDATE_FIRMWARE_VERSION_UPDATES,
          payload: response,
        })
      )
      .then(() => dispatch(getFirmwareVersionUpdates()));
}
